module.exports = __webpack_public_path__ + "static/img/banner.191ab1d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_11/banner.jpg
// module id = j8O1
// module chunks = 0